import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormLongPDFNoBackground} from '../../../components/DemoFormLongPDFNoBackground.jsx';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import MultimedialPanel from '../../../components/MultimedialPanel';
const Home = (props) => {    
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;   


    return (
        <Layout  bodyClass="fair-equitable-compensation" ontouchstart>
            <SEO title="Offering Equitable Compensation | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="Keep pay equitable by planning for compensation with inclusivity in mind. Use this guide to assess payroll data and identify disparities to address them head-on."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Offering Equitable Compensation | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="Keep pay equitable by planning for compensation with inclusivity in mind. Use this guide to assess payroll data and identify disparities to address them head-on." />
                <meta property="og:image" content={`https://www.charthop.com/landings/fair-equitable-compensation.jpg`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Offering Equitable Compensation | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="Keep pay equitable by planning for compensation with inclusivity in mind. Use this guide to assess payroll data and identify disparities to address them head-on." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/fair-equitable-compensation.jpg`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>
            
            {/* HEADER h4*/}
            <section className="hero-fair-equitable-compensation">
				<div className="row bottom-formPDF sectionSpacing contentBlock section-big">
					<div className="headerContent col-md-6 col-sm-12 text-left">
						<h1 className="h1-correct">Download the ultimate <span class="forced-br"><br></br></span>e-book on how to offer fair, equitable compensation.</h1>
					</div>
				</div>
                <div className="row top-formPDF sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormLongPDFNoBackground pdfUrl={'/resources/fair-equitable-compensation.pdf'} source={"resources-fair-compensation-PDF-contentdownload-header"}/>
				</div>
			</section>

            
            <section className="sectionSpacing flex-centeredColumn ebook">
                <div className="contentBlock">
                    <h2 className="text-center mt-0  sectionSpacing-Margin h2-size">Keep your pay equitable by planning for compensation with inclusivity in mind.</h2>
                    <h4 class="text-center my-2">In this e-book you'll learn how to: </h4>
                    <div className="flex-centeredColumn contentBlock">
                        <div className="pgc1">
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Gather and assess payroll and employee data</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Investigate existing gaps to ensure fairness</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Take action to correct unfair pay disparities</p>
                                </div>
                            </div>
                        </div>		
                        <h2 className="h1-lightblue stillH1 text-center mt-4 mb-3">It's time to go from being reactive, to being proactive.</h2>
                    </div>
                </div>
            </section>

            <section className="drive-comprehensive sectionSpacing mx-0 mt-0 backgroundGradientContainer">
                <div className="contentBlock">
                    <h2 className="text-center mt-0 sectionSpacing-Margin">Drive a comprehensive DEI Strategy with ChartHop</h2>
                    <h4 className="text-center mt-0 sectionSpacing-Margin">Understand how key factors differ across genders, ethnicities, generations & more. </h4>
					<div className="pgc1">
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Cash Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Equity Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Total Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Levels & Titles</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Reviews</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions & Raises </p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Span of Control</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Engagement & Satisfaction </p>
                            </div>
                        </div>
                    </div>
					<p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
				</div>
            </section>

             {/* TRUSTED */}
             <section className="customer testimonial-container pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>

            <section className="sectionSpacing flex-centeredColumn backgroundGradientContainer">
                <h2 className="text-center mt-0 sectionSpacing-Margin">The People Analytics dashboards you've always wanted.</h2> 
                <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                        <div className="svg-info-card-3col">
							<img src={'/product/people-analytics/create.svg'} alt="Insight" />
							<h3>Easy to create</h3>
							<p>Build or edit pre-made reports to gain insights in seconds. </p>
						</div>
                         <div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg'} alt="Update" />
							<h3>Always up to date</h3>
							<p>Integrate your existing systems for seamless, daily updates. </p>
						</div>

						<div className="svg-info-card-3col">
							<img src={'/product/people-analytics/customize.svg'} alt="Customize" />
							<h3>Highly customizable </h3>
							<p> Personalize reports with custom data, filters & complex calculations.  </p>
						</div>
					</div>
			    </div>
            </section>                       
            
            <section className="sectionSpacing pb-lg-0" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Centralize and collect data"
                        link="/product/people-analytics/Integration_reports-2.mp4"
                        type="video"
                        paddingClass="padding-top-video-1"
                        content={
                            <React.Fragment>
                                <p>Report across any HR system. Integrate data from your HRIS, ATS, Equity, Performance, Identity Management tools and more.</p>
                                <p>Collect any data directly through ChartHop, without an additional survey tool.</p>                            
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

		
			<section className="sectionSpacing py-0" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Visualize your data"
                        link="/product/org-chart/hero.mp4"
                        type="video"
                        paddingClass="padding-top-video-2"
                        content={
                            <React.Fragment>
                                <p>Go beyond the the spreadsheets and graphs. Bring People data to life like never before.</p>                            
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            <section className="sectionSpacing pt-lg-0 pb-md-7 pb-sm-5" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Analyze your trends"
                        link="/product/2105-refresh/reports.png"
                        type="image"
                        paddingClass="padding-top-video-3"
                        content={
                            <React.Fragment>
                                <p>Understand your evolution through time-tracked changes. Dissect data across any dimension.</p>                            
                            </React.Fragment>
                        }
                    />
				</div>
			</section>           

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
            <h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2>

                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-google.jpg' alt="Google" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>                     

                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">

                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>

            {/* CONTACT FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-fair-compensation-demo-bottom"} headertext={HtmlParser("<h2>It's time to turn data into action.</h2><h2>We’re here to help.</h2>")}/>
            </section>

        </Layout>
    );
};


export default Home;

export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;